
import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default defineComponent({
  name: 'Player',
  computed: {
    ...mapGetters(['playing']),
    ...mapState(['seek', 'duration', 'playerProgress', 'current_song']),
  },
  methods: {
    ...mapActions(['toggleSong', 'updateSeek']),
  },
});
